import React from 'react';
import { TextOnlyUnderlinedButton } from '../../Components';
import { routes } from '../../routes';
import { translate } from './translate';
import { useHistory } from 'react-router-dom';

export const SelectOrderButton = (props) => {
  const history = useHistory();
  const handleClick = () => {
    props.setCurrentOrder(props.id);
    history.push(routes.currentOrder);
  };
  return (
    <TextOnlyUnderlinedButton
      onClick={handleClick}
      text={translate('selectOrder')}
    />
  );
};
